export default {
  navigation: {
    id: 'bo_seller-options-shipping-navigation',
    defaultMessage: 'Navigation',
  },
  productCategoryRulesTab: {
    id: 'bo_seller-options-shipping-category_rules_tab',
    defaultMessage: 'Product category rules',
  },
  onboardingModalTitle: {
    id: 'merchant_options_shipping_onboarding_modal_title',
    defaultMessage: 'Add your shipping methods',
  },
  onboardingModalDescription: {
    id: 'merchant_options_shipping_onboarding_modal_description',
    defaultMessage:
      'Let’s make sure that your items get to where they’re going.',
  },
  onboardingModalToDoSection: {
    id: 'merchant_options_shipping_onboarding_modal_to_do_section',
    defaultMessage:
      'Start by setting up your shipping methods by country and item category. For most items, you must at least include: {listOptions, html}',
  },
  onboardingModalToDoFirstOption: {
    id: 'merchant_options_shipping_onboarding_modal_to_do_first_option',
    defaultMessage: 'A standard shipping option included in the item price',
  },
  onboardingModalToDoSecondOption: {
    id: 'merchant_options_shipping_onboarding_modal_to_do_second_option',
    defaultMessage: 'An express shipping option',
  },
  onboardingModalDoneSection: {
    id: 'merchant_options_shipping_onboarding_modal_done_section',
    defaultMessage: 'Head back to the Onboarding page to continue.',
  },
  onboardingModalButtonLabel: {
    id: 'merchant_options_shipping_onboarding_modal_button_label',
    defaultMessage: 'Add shipping methods',
  },
  oldVersionTitle: {
    id: 'bo_seller.options.shipping.old_version_title',
    defaultMessage:
      'We rolled out a new version of the shipping tab. Want to see the old one? {link, html}',
  },
  oldVersionLink: {
    id: 'bo_seller.options.shipping.old_version_link',
    defaultMessage: 'Click here',
  },
} as const
